<template>
  <span
    class="inline-block fill-current"
    :class="$style.icon"
    v-html="icon"
    v-on="$listeners"
  />
</template>

<script>
import { loadIcon } from '@common/utils/loadIcon'

export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      icon: ''
    }
  },

  beforeCreate () {
    loadIcon(this.$options.propsData.name)
      .then(icon => {
        this.$nextTick(() => {
          this.icon = icon
        })
      })
  },

  watch: {
    name: function (name) {
      loadIcon(name)
        .then(icon => {
          this.icon = icon
        })
    }
  }
}
</script>

<style lang="scss" module>
.icon > svg {
  height: .95em;
  vertical-align: -.1em;

  // IE hack
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    max-width: 1.2em;
  }
}
</style>
